import React, { useState, useEffect, useRef, useCallback } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useRouteMatch, useHistory } from "react-router-dom";

import {
  fetchStoryboard, unPublishPage, updateStoryboard, invalidateUnpublishPage, updateAppearance, fetchDomains,
  updateStoryboardItem,
  storyboardLevelSeekIndex
} from 'actions/storyboard';
import StoryboardContext from 'components/Storyboard/context';
import cx from 'classnames';
import _, { set } from 'lodash';
import { IKImage } from 'imagekitio-react';
import { ChromePicker } from 'react-color';
import dateformat from "dateformat";
import { toast } from "react-toastify";

import {
  Row,
  Col,
  Form,
  FormCheck,
  Button,
  InputGroup,
  Modal,
  Image,
  Dropdown,
  OverlayTrigger,
  Popover
} from "react-bootstrap";

import { MediaLibraryModal } from 'components/MediaLibrary';
import trackingPixels from './trackingPixels';
import { ContentGating } from './gating';
import { SuccessToast, FailureToast } from "components/Toast";

import { colorToString } from 'components/Editor/helper/color';
import { VideoView } from "components/Editor/widgets/background";

import ImageTools from 'services/imagetools.service';
import storyboardRoleService from 'services/storyboardRoles.service';
import userRoleService from 'services/userRoles.service';
import { getBaseUrl, guid } from 'services/util';
import { CopyEmbedCodeButton } from "components/Buttons";
import TruncatedTextWithTooltip from "components/TruncatedTextWithTooltip";
import { Property } from "components/Editor/components/properties";
import { createMixpanelEvent } from "actions/mixpanel";
import { 
  MIXPANEL_CUSTOM_SCRIPT_ENABLED, MIXPANEL_PAGE_VIEWED, MIXPANEL_PAGE_VIEWED_STORYBOARD_SETTINGS, 
  MIXPANEL_PASSWORD_ENABLED, MIXPANEL_FAV_ICON_ADDED, MIXPANEL_SITE_VERIFICATION_CONFIGURED, 
  MIXPANEL_TRACKING_PIXEL_ADDED, MIXPANEL_GATING_CONFIGURED } from "constants/mixpanelEvents";
import { getPageViewedEventPayload, getStoryboardMixpanelEventPayload, getStoryboardType } from "services/mixpanelUtil";
import { pageSeekIndexing } from "actions/pages";

import { Loader } from "components/ApplicationLoader";
import { INTERACTIVE_CONTENT_TYPES, MULTIPAGE_SEEK_INDEXING_STORYBOARDS, SLIDE_STORYBOARDS, STORYBOARD_TYPES } from "constants/storyboardType";
import { SEEK_IN_PROGRESS, SEEK_STATUS } from "constants/seekEnums";
import styles from './websiteSettings.module.scss';


export default function WebsiteSettings() {
  const storyboardContext = React.useContext(StoryboardContext);
  const dispatch = useDispatch();
  const history = useHistory();

  let { path, url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);

  const uploadIconRef = React.useRef(null);
  const socialRef = React.useRef(null);
  const [trackingType, setTrackingType] = useState('');
  const [isSiteVerification, setIsSiteVerification] = useState(false);
  const [isFavIcon, setIsFavIcon] = useState(false);
  const [isTrackingPixelAdded, setIsTrackingPixelAdded] = useState(false);
  const [isPasswordEnabled, setIsPasswordEnabled] = useState(false);
  const [newlyAddedPixels, setNewlyAddedPixels] = useState([]);

  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard.item", null));
  const storyboardType = _.get(storyboard, 'type', '');
  const updating = useSelector(state => _.get(state, "storyboards.storyboard.updating", false));
  const unpublishing = useSelector(state => _.get(state, "storyboards.storyboard.item.page.unpublish.unpublishing", false));
  const unpublished = useSelector(state => _.get(state, "storyboards.storyboard.item.page.unpublish.success", false));
  const workspace = useSelector(state => _.get(state, 'workspaces.workspace.item', null));
  const domain = _.get(workspace, 'defaultDomain', {});
  const error = useSelector((state) => _.get(state, "storyboards.storyboard.error", null));
  const loading = useSelector((state) => _.get(state, "storyboards.storyboard.loading", false));
  const domains = useSelector((state) => _.get(state, "storyboards.storyboard.domains", null));

  const [selectedDomain, setSelectedDomain] = useState({});
  const [showAlert,setShowAlert] =useState(false);

  const storyboardCloneRef = useRef(_.clone(storyboard));
  const storyboardCloneState = storyboardCloneRef.current;

  const favIcon = _.get(storyboard, 'favIcon.appleTouchIcon180x180') 
  || _.get(storyboard, 'favIcon') 
  || null;
  const storyboardName = _.get(storyboard, 'name', '');
  const page = _.get(storyboard, 'page');
  const published = _.get(page, 'published', false);
  const pageId = _.get(page, 'id');
  const seekEnabled = _.get(page, 'seekEnabled', false);
  const seekStatus = _.get(page, 'seekStatus');
  const seekEnabledWorkspace = useSelector(state => { return _.get(state, 'workspaces.workspace.item.seekSettings.seekEnabled', false) });
  const alias = _.get(storyboard, 'page.canonical', '');
  const trackingPixels = _.get(storyboard, 'trackingPixels', []);
  const appearance = _.get(storyboard, 'appearance', {});
  const excludeFromSearch = _.get(storyboard, 'excludeFromSearch', false);
  const password = _.get(storyboard, 'password', '');
  const passwordEnabled = _.get(storyboard, 'passwordProtected', false);
  const notifications = _.get(storyboard, 'notifications', {});
  const siteVerification = _.get(storyboard, 'siteVerification', {});
  const customScript = _.get(storyboard, 'customScript', null);
  const viewer = _.get(storyboard, 'viewer', '') || 'BINGE';
  const darkViewer = _.get(storyboard, 'darkViewer', false);
  const social = _.get(storyboard, 'social', {});

  const [state, setState] = useState({
    errors: {},
    showUnpublish: false,
    showMedia: false,
    resetting: false,
    domain: _.get(selectedDomain, 'id'),
  });

  useEffect(() => {
    dispatch(fetchStoryboard(storyboard.id));
  }, []);

  useEffect(() => {
    dispatch(fetchDomains());
    if(storyboard){
      var mixPanelPayload = getPageViewedEventPayload(MIXPANEL_PAGE_VIEWED_STORYBOARD_SETTINGS, storyboard.id, storyboard.name, storyboard.type)
      dispatch(createMixpanelEvent(MIXPANEL_PAGE_VIEWED, mixPanelPayload))
    }
  }, []);

  useEffect(() => {
    if(!updating) {
      storyboardCloneRef.current = storyboard;
    }
  }, [updating]);

  useEffect(() => {
    if (storyboard) {
      updateStoryboardState();
    }
  }, [storyboard]);

  useEffect(() => {
    if (error) {
      let errorDescription = "Unable to update storyboard";

      var errorCode = _.get(error, 'errors[0].message');
      if (errorCode === 'alias.duplicate') {
        errorDescription = "The entered Site URL already exists";
      }

      toast(
        <FailureToast
          heading={`Failure`}
          description={errorDescription}
        />,
        {
          type: toast.TYPE.DEFAULT,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );

      updateStoryboardState();
    }
  }, [error]);


  useEffect(() => {
    if (unpublished) {
      setState(state => {
        return {
          ...state,
          showUnpublish: false,
          errors: {}
        }
      });
      toast(
        <SuccessToast
          heading={`Success`}
          description={`${_.get(storyboard, 'name')} unpublished successfully`}
        />,
        {
          type: toast.TYPE.DEFAULT,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        })
      dispatch(invalidateUnpublishPage());
    }

  }, [unpublished])

  const handleUploadFavIcon = (e) => {
    setIsFavIcon(true);
    if (!e.target.files) {
      return;
    }
    const fileType = e.target.files[0]?.type;
    const acceptFiles = ["image/x-icon", "image/vnd.microsoft.icon", "image/png", "image/jpeg", "image/gif", "image/svg+xml"];

    if(!acceptFiles.includes(fileType)) {
      toast(
        <FailureToast
          heading={`Failure`}
          description={`File type ${fileType} is not supported`}
        />,
        {
          type: toast.TYPE.DEFAULT,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
      return;
    }

    ImageTools.resize(e.target.files[0], {
      width: 196, // maximum width
      height: 196 // maximum height
    }, (blob, didItResize) => {
      var reader = new FileReader();
      reader.onload = (e) => {
        dispatch(updateStoryboardItem({ ...storyboard, favIcon: e.target.result }));
      };

      reader.readAsDataURL(blob);
    });
  }

    const toggleSeekIndexing = () => {
      const request = {
        contentType: 'page',
        content: pageId,
        contentMapping: null,
        storyboard: _.get(storyboard, 'id'),
        storyboardType: _.get(storyboard, 'type'),
        addStoryboard: !seekEnabled,
        seekEnabled: seekEnabled,
        seekStatus: seekStatus
      };
  
      dispatch(pageSeekIndexing(pageId, request));
    }
  
    const seekActivation =()=> {
      switch (true) {
        case (seekEnabled || (seekStatus == 'PROCESSING' || seekStatus == 'REQUESTED')):
          return true;
      
        case (!seekEnabled && (seekStatus == 'COMPLETED' || seekStatus == null)):
          return false;
      }
    }

  const getSocialIconUrl = () => {
    return _.get(social, 'url', null);
  }

  const handleNameChange = (e) => {
    dispatch(updateStoryboardItem({
      ...storyboard,
      name: e.target.value
    }));
  }

  const handleAliasChange = (e) => {
    dispatch(updateStoryboardItem({
      ...storyboard,
      page: {
        ...storyboard.page,
        canonical: e.target.value
      }
    }));
  }

  const handleChangeSocialIcon = (media) => {
    dispatch(updateStoryboardItem({
      ...storyboard,
      social: media[0],
    }));
    setState(state => {
      return {
        ...state,
        showMedia: false
      }
    });
  }

  const toggleUploadMedia = (e) => {
    setState(state => {
      return {
        ...state,
        showMedia: !state.showMedia
      }
    })
  }

  const handleResetClick = () => {
    setState((prev) => ({
      ...prev,
      resetting: true
    }));
    dispatch(fetchStoryboard(storyboard.id));
    setShowAlert(false)
  }

  const updateStoryboardState = () => {
    setState((state) => {
      return {
        ...state,
        errors: _.get(state, "errors", {}),
        domain: selectedDomain?.id || "",
        resetting: false
      };
    });

    let domainUrl = !_.isEmpty(_.get(selectedDomain, 'url')) ? selectedDomain : (_.get(storyboard,'domain') || domain);
    setSelectedDomain(domainUrl);
  }

  const mixpanel = _.get(storyboard, 'mixpanel', []);
  const gatingId = _.get(storyboard, 'gatingId', []);
  const triggerTypeMapping = {
    INTERACTIVE_SECTION: "Sections",
    INTERACTIVE_DOWNLOAD: "On Download",
    TIME: "Time",
    PERCENTAGE: "Percentage"
  };

  const handleSave = () => {
    if (!storyboardRoleService.canEditStoryboard(storyboard)) {
      toast(
        <FailureToast
          heading={`Failure`}
          description={`Access denied`}
        />,
        {
          type: toast.TYPE.DEFAULT,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
      return;
    }

    const gatingConfigurations = _.get(storyboard, 'gatingConfigurations', []);

    let errorMessage = '';

    if (Array.isArray(gatingConfigurations)) {
      gatingConfigurations.forEach((item) => {
        if(errorMessage) return;

        if(item.enabled && (!item.gating || (item.autoGating && !item.conversionType))) {
          errorMessage = `A gating screen is required. Please select one.`;
          return;
        }

        if ((!item.id || (mixpanel && Object.keys(mixpanel).length > 0 && item.uid === gatingId)) && item.enabled &&
        !(
          (item.trigger?.value === null || item.trigger?.value === "") &&
          (item.trigger?.type === "INTERACTIVE_SECTION" || item.trigger?.type === "TIME")
        )) {
          const smartGating = _.get(item, "smart", "false")
          const mixpanelPayload = getStoryboardMixpanelEventPayload(
          storyboard.id,
          storyboard.name,
          storyboard.type
        );
        const updatedPayload = {
          ...mixpanelPayload,
          gating_type: "Page",
          trigger: smartGating? "Smart Gating" : triggerTypeMapping[_.get(item, "trigger.type", "")] || _.get(item, "trigger.type", ""),
          optional: _.get(item, 'optional', ''),
        };
        dispatch(createMixpanelEvent(MIXPANEL_GATING_CONFIGURED, updatedPayload));
      }
    });
    } 

    if(errorMessage) {
      toast(
        <FailureToast
          heading={`Failure`}
          description={errorMessage}
        />,
        {
          type: toast.TYPE.DEFAULT,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
      return;
    }

    let errors = validateForm();

    if (Object.keys(errors).length > 0) {
      setState(state => {
        return {
          ...state,
          errors: errors
        }
      });

      return;
    }

    var request = {};

    if (_.get(storyboardCloneState, 'name') !== storyboardName) {
      request = {
        ...request,
        name: storyboardName
      }
    }
    if (_.get(storyboardCloneState, 'page.canonical') !== alias) {
      request = {
        ...request,
        alias
      }
    }

    if (!_.isEqual(_.get(storyboardCloneState, 'favIcon'), _.get(storyboard, 'favIcon'))) {
      request = {
        ...request,
        favIcon
      }
    }

    if (_.get(storyboardCloneState, 'viewer') !== viewer
      || _.get(storyboardCloneState, 'darkViewer') !== darkViewer) {
      request = {
        ...request,
        viewer,
        darkViewer
      }
    }

    if(isFavIcon) {
        setIsFavIcon(false);
        const mixPanelPayload = getStoryboardMixpanelEventPayload(storyboard.id, storyboard.name, storyboard.type)
      dispatch(createMixpanelEvent(MIXPANEL_FAV_ICON_ADDED, mixPanelPayload));
    }

    if (trackingPixels) {
      request = {
        ...request,
        trackingPixels
      }
    }

    const trackingTypeMapping = {
      GOOGLE_ANALYTICS: 'Google Analytics',
      GOOGLE_TAG_MANAGER: 'Google Tag Manager',
      FACEBOOK: 'Facebook',
      LINKEDIN: 'LinkedIn',
      MUNCHKIN: 'Munchkin',
      SIXSENSE: '6sense',
    };
    if (newlyAddedPixels.length > 0) {
      newlyAddedPixels.forEach((pixel) => {
      const mixpanelPayload = getStoryboardMixpanelEventPayload(storyboard.id, storyboard.name, storyboard.type);
      mixpanelPayload.tracking_type = trackingTypeMapping[pixel.type];
       dispatch(createMixpanelEvent(MIXPANEL_TRACKING_PIXEL_ADDED, mixpanelPayload));
      });
      setNewlyAddedPixels([]);}

    if (isSiteVerification) {
      setIsSiteVerification(false);
      {const mixPanelPayload = getStoryboardMixpanelEventPayload(storyboard.id, storyboard.name, storyboard.type)
        dispatch(createMixpanelEvent(MIXPANEL_SITE_VERIFICATION_CONFIGURED, mixPanelPayload));  
    }
  }

    if (siteVerification) {
      request = {
        ...request,
        siteVerification
      }
    }

    if (appearance) {
      const mediaId = _.get(appearance, 'background.media.id');
      request = {
        ...request,
        appearance: {
          ...appearance,
          background: {
            ...appearance.background,
            media: mediaId
          },
          disableDownload: appearance.disableDownload
        }
      }
    }

    if (_.get(storyboardCloneState, 'excludeFromSearch') !== excludeFromSearch) {
      request = {
        ...request,
        excludeFromSearch,
        ...(storyboard.type === STORYBOARD_TYPES.INTERACTIVE_CONTENT_V2 && {
          storyBoardLevelIndex: true
        })
      }
    }

    if ((passwordEnabled && password) || (!passwordEnabled && !password)) {
      request = {
        ...request,
        password: password,
        passwordEnabled: passwordEnabled
      }
    }

    if (isPasswordEnabled) {
      setIsPasswordEnabled(false);
      const mixPanelPayload = getStoryboardMixpanelEventPayload(storyboard.id, storyboard.name, storyboard.type)
      dispatch(createMixpanelEvent(MIXPANEL_PASSWORD_ENABLED, mixPanelPayload));
    }

    let socialId = _.get(social, 'id', null);
    request = {
      ...request,
      social: socialId
    }

      if (notifications) {
        request = {
          ...request,
          notifications: notifications
      }
    }

    if(selectedDomain){
      request={
        ...request,
        domain: _.get(selectedDomain, 'id')
      }
    }

    if (customScript != null) {
      request = {
        ...request,
        customScript
      }

      var customScriptUpdated = _.get(state, 'customScriptUpdated', false)

      if(customScriptUpdated && customScript!== ""){
        const mixPanelPayload = getStoryboardMixpanelEventPayload(_.get(storyboard, 'id', ''), _.get(storyboard, 'name', ''), _.get(storyboard, 'type', ''));
        dispatch(createMixpanelEvent(MIXPANEL_CUSTOM_SCRIPT_ENABLED, mixPanelPayload))

        setState((state) => {
          return {
            ...state,
            customScriptUpdated: false
          }
        })
      }
    }

    dispatch(
      updateStoryboard(storyboard.id, request, () => {
        setState(state => {
          return {
            ...state,
            errors: {}
          }
        });

        setShowAlert(false)

        toast(
          <SuccessToast
            heading={`Success`}
            description={`${storyboardName} changes saved successfully`}
          />,
          {
            type: toast.TYPE.DEFAULT,
            position: toast.POSITION.BOTTOM_RIGHT,
            autoClose: 3000,
          }
        );
      })
    );
  }

  const validateForm = () => {
    var errors = new Array();
    var aliasRegex = /^[a-z_-]|[`\s!@#$%^&*()+\=\[\]{};':"\\|,.<>\?~]/;
    var slashRegex = /([^:]\/)\/+/

    if (!storyboardName || storyboardName.trim() === '') {
      errors['name'] = 'Please provide a valid name';
    }

    if (INTERACTIVE_CONTENT_TYPES.includes(storyboard.type) && (!alias || alias.trim() === '' || aliasRegex.test(alias) || slashRegex.test(alias) || alias.startsWith('//'))) {
      errors['alias'] = 'Please provide valid alias';
    }

    return errors;
  }

  const handleInviteClick = () => {
    history.push(`${baseUrl}/storyboards/${storyboard.id}/permissions`);
  }

  const toggleUnpublish = () => {
    setState(state => {
      return {
        ...state,
        showUnpublish: !state.showUnpublish
      }
    });
  }

  const handleToggleDownload = () => {
    dispatch(updateStoryboardItem({
      ...storyboard,
      ...appearance,
      disableDownload:{
        ...appearance.disableDownload,
        disableDownload: !appearance.disableDownload
      }
    }));
  }

  const handleToggleExcludeFromSearch = () => {
    dispatch(updateStoryboardItem({ storyboard, excludeFromSearch: !excludeFromSearch }));
  }

  const handleUnpublish = () => {
    dispatch(unPublishPage(storyboard.page.id));
  }

  const handleSiteVerificationChange = (e) => {
    setIsSiteVerification(true);
    let { name, value } = e.target;
    dispatch(updateStoryboardItem({
      ...storyboard,
      siteVerification: {
        ...storyboard.siteVerification,
        [name]: value
      }
    }));
  }

  const handleAddNewPixel = (pixel) => {
    var newPixel = {
      uid: guid(),
      type: pixel.key,
      value: ""
    }

    dispatch(updateStoryboardItem({
      ...storyboard,
      trackingPixels: trackingPixels
        ? [...trackingPixels, newPixel]
        : [newPixel]
    }));
    setNewlyAddedPixels((prev) => [...prev, newPixel]);
  }

  const handleTrackingPixelChange = (key, id, e) => {
    setIsTrackingPixelAdded(true);
    setTrackingType(key);

    var trackingPixel = {};
    if (trackingPixels) {
      var index = trackingPixels.findIndex(pixel => pixel.uid === id);
      if (index === -1) {
        trackingPixel = {
          uid: id,
          type: key,
          value: e.target.value
        }

        dispatch(updateStoryboardItem({
          ...storyboard,
          trackingPixels: [
            ...trackingPixels,
            trackingPixel
          ]
         }));

      } else {
        trackingPixel = trackingPixels[index];
        trackingPixel.value = e.target.value;
        dispatch(updateStoryboardItem({
          ...storyboard,
          trackingPixels: [
            ...trackingPixels.slice(0, index),
            Object.assign({}, trackingPixels[index], trackingPixel),
            ...trackingPixels.slice(index + 1)

          ]
         }));
      }
    }
  }

  const deleteTrackingPixel = (id, e) => {
    var index = trackingPixels.findIndex(pixel => pixel.uid === id);
    if (index > -1) {
      dispatch(updateStoryboardItem({
        ...storyboard,
        trackingPixels: [
          ...trackingPixels.slice(0, index),
          ...trackingPixels.slice(index + 1),
        ]
       }));
    }
  }

  const handlePasswordChange = (e) => {
    setIsPasswordEnabled(true);
    dispatch(updateStoryboardItem({
      ...storyboard,
      password: e.target.value,
      passwordProtected: e.target.value !== '' ? true : false
    }));
  }

  const toggleDisableProtect = () => {
    dispatch(updateStoryboardItem({
      ...storyboard,
      passwordProtected: !passwordEnabled
    }));
  }

  const handleNotificationChange = (id, field, value) => {
    var updated = notifications || {};
    var updated = {
      ...updated,
      [field]: {
        ...updated[field],
        [id]: value
      }
    }
    dispatch(updateStoryboardItem({
      ...storyboard,
      notifications: updated
    }));
  }

  useEffect(() => {
    if (!passwordEnabled && !_.isEmpty(password)) {
      dispatch(updateStoryboardItem({
        ...storyboard,
        password: ''
      }));
    }
  }, [passwordEnabled])

  const handleCustomScriptChange = (e) => {
    setState((state) => {
      return {
        ...state,
        customScriptUpdated: true
      }
    });
    dispatch(updateStoryboardItem({
      ...storyboard,
      customScript: e.target.value
    }));
  }

  const handleAssetViewerType = (value) => {
    dispatch(updateStoryboardItem({
      ...storyboard,
      viewer: value,
      darkViewer: value === "BINGE" ? false : darkViewer
    }));
  }

  const handleDarkView = (value) => {
    dispatch(updateStoryboardItem({
      ...storyboard,
      darkViewer: value
    }));
  }

  if(loading && !state.resetting) {
    return (
      <div className={styles.storyboardLoadingAnimationContainer}>
        <Loader className={styles.loadingAnimation} title="Loading..." />
      </div>
    ) 
  }
  
  return (
    <>
    <div className={styles.siteSettingsContentWrapper}>
      <div className={styles.siteSettingsContent}>
        <header className={styles.contentHeader}>
          <div>
            <div className={styles.header}>Site Settings</div>
            <div className={styles.description}>Here’s where the magic happens. </div>
          </div>
            <Button size="sm" className={styles.actionButton} variant="primary" onClick={handleInviteClick} disabled={!storyboardRoleService.canManageStoryboard(storyboard)}>
              <i className={cx("cleverstory-user-role", styles.userIcon)} /> Invite People
            </Button>
        </header>
        <Row className={styles.siteSettingsRow}>
          <Col md={12} className={cx(styles.siteSettingsColumn)}>
            <StoryboardInfoView
              toggleUnpublish={toggleUnpublish}
              name={storyboardName}
              password={passwordEnabled}
              onNameChange={handleNameChange}
              error={state.errors.name}
              selectedDomain={selectedDomain}
              resetting={state.resetting}
            />
          </Col>
        </Row>
        <Row className={styles.siteSettingsRow}>
          <Col md={6} className={cx(styles.siteSettingsColumn)}>
              <div
                className={cx(
                  styles.siteSettingsContainer,
                  styles.aliasContainer
                )}
              >
                <div className={styles.siteUrlHeader}>
                  <SiteSettingHeader
                    title="Site Url"
                    description="Get a branded domain so visitors can easily find your site."
                  />
                  {_.get(domains, 'items', []).length > 1 && 
                  <Dropdown className={cx(styles.storboardTypeDropdown, {[styles.disabled] : !storyboardRoleService.canEditStoryboard(storyboard)})} data-track-event="Mixpanel" data-track-props="Choose Domain">
                    <Dropdown.Toggle
                      as={CustomFilterDropdown}
                      id="dropdown-custom-components"
                      className={styles.selected}
                    >
                      <i className={"cleverstory-web"} />
                      <span className={styles.dropdownLabel}>Choose Domain</span>
                    </Dropdown.Toggle>
                 <Dropdown.Menu className={styles.dropdownMenu}>
                    {_.get(domains, 'items', []).length > 0 ?
                    _.map(domains.items, (option, index) => (
                     <Dropdown.Item
                      active={option.id === _.get(selectedDomain, 'id')}
                      onClick={() => {
                        if ((_.get(storyboard, 'domain.id') ?? domain?.id) !== option.id) {
                            setShowAlert(true);
                          }else{
                            setShowAlert(false);
                          }
                        setSelectedDomain(option);
                        }}
                      key={index}
                      eventKey={index}
                      >
                      {option.url}
                      </Dropdown.Item>
                      )):
                      <Dropdown.Item disabled>
                        <p style={{ textAlign: "center" }}>No result</p>
                      </Dropdown.Item>
                    }
                  </Dropdown.Menu>
                  </Dropdown>
                  }
                </div>
                {storyboardRoleService.canEditStoryboard(storyboard) && (
                  <Form className={styles.form}>
                    <Form.Group className={styles.siteFormGroup}>
                      <Form.Label>Your vanity URL</Form.Label>
                      <InputGroup className={styles.siteInputGroup}>
                        <InputGroup.Text id="basic-addon3" 
                          className={!INTERACTIVE_CONTENT_TYPES.includes(storyboardType) && styles.domainUrlWidth}>
                          {selectedDomain &&
                            selectedDomain.url &&
                            selectedDomain.url}
                        </InputGroup.Text>
                        {INTERACTIVE_CONTENT_TYPES.includes(storyboardType) && (
                        <Form.Control
                          id="basic-url"
                          type="text"
                          placeholder="Enter storyboard alias"
                          value={alias}
                          onChange={handleAliasChange}
                          aria-describedby="basic-addon3"
                          isInvalid={state.errors.alias}
                        />
                        )}
                        <Form.Control.Feedback
                          type="invalid"
                          className={styles.error}
                        >
                          {state.errors.alias}
                        </Form.Control.Feedback>
                      </InputGroup>
                    </Form.Group>
                  {INTERACTIVE_CONTENT_TYPES.includes(storyboardType) && (
                    <Form.Group controlId="indexing" className={cx(styles.smallGroup, styles.flexFormGroup)}>
                      <div className={styles.flexFormGroup}>
                        <Form.Label className={styles.inlineLabel}>
                          Exclude from indexing
                        </Form.Label>
                        <Form.Check type="switch" className={styles.switchButton}>
                          <FormCheck.Input
                            isvalid
                            onChange={handleToggleExcludeFromSearch}
                            checked={excludeFromSearch}
                          />
                        </Form.Check>
                      </div>
                      {showAlert&& (
                        <div className={styles.siteUrlAlert}>
                          <i className={"cleverstory-warning"} />
                          <span>
                            Ensure the domain is verified with search engines.
                          </span>
                        </div>
                      )}
                    </Form.Group>
                  )}
                  {storyboardType === "INTERACTIVE_CONTENT" && seekEnabledWorkspace && published && (
                    <Form.Group controlId="seekIndexing" className={cx(styles.indexSmallGroup, styles.flexFormGroup)}>
                      <Form.Label className={styles.inlineLabel}>Index for seek</Form.Label>
                        {(seekStatus == "PROCESSING" ||
                            seekStatus == "REQUESTED") && (
                              <div className={styles.loader}>
                                <span className={styles.text}>Indexing...</span>
                                  <Button variant="info" onClick={toggleSeekIndexing}>
                                    <i className={cx("cleverstory-sync")} />
                                  </Button>
                              </div>
                        )}
                      <Form.Check type="switch" className={styles.switchButton}>
                        <FormCheck.Input disabled={seekStatus == "PROCESSING" || seekStatus == "REQUESTED"} isvalid onMouseDown={toggleSeekIndexing} checked={seekActivation()} />
                      </Form.Check>
                    </Form.Group>
                  )}
                  {MULTIPAGE_SEEK_INDEXING_STORYBOARDS.includes(storyboardType) && seekEnabledWorkspace && published && (
                    <StoryboardLevelIndexing storyboard={storyboard} />
                  )}
                  </Form>
                )}

                {!storyboardRoleService.canEditStoryboard(storyboard) && (
                  <div
                    onClick={() => {
                      navigator.clipboard.writeText(
                        `${_.get(selectedDomain, 'url')}${alias}`
                      );
                    }}
                    className={styles.siteurlView}
                  >
                    <span
                      className={styles.siteUrl}
                    >{`${selectedDomain.url}${alias}`}</span>
                    <i className={cx("cleverstory-copy")}></i>
                  </div>
                )}
              </div>

            <div className={cx(styles.siteSettingsContainer, styles.aliasContainer)}>
              <SiteSettingHeader
                title='Fav icon'
                description='Get a custom favicon to help visitors recognize your brand and to stand out in their browser tabs.'
              />

              <div className={styles.FavIconContainer}>
                <div className={styles.uploadFavIcon}>
                  <div className={styles.imageContainer}>
                    {favIcon ?
                    <>
                      <img src={favIcon} alt="" className={styles.favIcon} />
                      {storyboardRoleService.canEditStoryboard(storyboard) &&
                        <button className={styles.favCloseButton} onClick={() => {
                          dispatch(updateStoryboardItem({ ...storyboard, favIcon: null }));
                        }}>
                          <i className={cx('cleverstory-close')} />
                        </button>
                      }
                    </> :
                    <span className={styles.imageSize}>16x16</span>}
                  </div>
                  <div className={styles.uploadFavIconInput}>
                    {storyboardRoleService.canEditStoryboard(storyboard) &&
                      <Button variant="light" className={styles.uploadFavIconButton} onClick={() => { uploadIconRef.current.click() }}>
                        <i className={cx('cleverstory-upload')}></i>
                        Upload Image
                      </Button>
                    }
                    {!storyboardRoleService.canEditStoryboard(storyboard) && !favIcon &&
                      <span className={styles.emptyMessage} >No Fav Icon</span>
                    }
                    <input
                      ref={uploadIconRef}
                      type="file"
                      accept="image/x-icon, image/vnd.microsoft.icon, image/png, image/jpeg, image/gif, image/svg+xml"
                      hidden
                      onChange={handleUploadFavIcon} />
                  </div>
                </div>
                <div className={styles.favIconOverlayContainer}>
                  <div className={styles.favIconOverlay}>
                    {favIcon &&
                      <img src={favIcon} alt="" className={styles.favIcon} />
                    }
                    <span className={styles.storyboardName}>{storyboardName}</span>
                  </div>
                </div>
              </div>
            </div>
            <div className={cx(styles.siteSettingsContainer, styles.aliasContainer)}>
              <SiteSettingHeader
                title='General social image'
                description='This image will be shared on social networks including Facebook and Twitter. It’s a great way to help visitors recognize your brand.'
              />

              <div className={styles.socialSharePreviewImage}>
                {getSocialIconUrl() &&
                  <ImageView
                    imageRef={socialRef}
                    url={getSocialIconUrl()}
                    width={'100%'}
                    height={'226px'} />}
                  {storyboardRoleService.canEditStoryboard(storyboard) ? (
                    getSocialIconUrl() ? (
                    <div className={styles.socialShareUploadWrapper}>
                      <Button className={cx(styles.socialShareUpload, styles.socialShareUploadWithImage)} size="sm" variant={"primary"} onClick={toggleUploadMedia}>
                        <i className={cx('cleverstory-upload', styles.uploadIcon)} />
                        <span className={styles.lable}>Upload Social Image</span>
                      </Button>
                      <button className={styles.socialShareUploadCloseButton} onClick={() => {
                          dispatch(updateStoryboardItem({ ...storyboard, social: null }));
                        }}>
                          <i className={cx('cleverstory-close')} />
                      </button>
                    </div> ): 
                    <Button className={styles.socialShareUpload} size="sm" variant={"light"} onClick={toggleUploadMedia}>
                      <i className={cx('cleverstory-upload', styles.icon)} />
                      <span className={styles.lable}>Upload Social Image</span>
                    </Button>) : null
                }
                {!storyboardRoleService.canEditStoryboard(storyboard) && !getSocialIconUrl() &&
                  <span className={styles.emptyMessage} >No Social Image</span>
                }
              </div>
            </div>

            <div className={cx(styles.siteSettingsContainer, styles.aliasContainer)}>
              <SiteSettingHeader
                title='Notification Triggers'
                description='Customize alerts for specific events, ensuring real-time notifications for crucial activities and engagements.'
              />

              <div className={cx(styles.notificationContainer, {[styles.disabled] : !storyboardRoleService.canEditStoryboard(storyboard)})}>
                <NotificationTrigger notification={notifications} handleChange={handleNotificationChange} storyboardType={storyboardType} />
              </div>
            </div>
            { !SLIDE_STORYBOARDS.includes(storyboardType) && 
              <div className={cx(styles.siteSettingsContainer, styles.aliasContainer)}>
                <SiteSettingHeader
                  title='Asset Viewer Trigger'
                  description='Choose Lightbox for a pop-up view or Binge for continuous scrolling.'
                />
                <div className={styles.assetViewerContainer}>
                  <div className={cx(styles.selectAssetViewer, {[styles.selectLightboxViewer] : state?.viewer !== "BINGE"})}>
                    <div className={styles.assetTypeContainer}>
                      <div className={styles.defaultAsset}>
                        <img 
                          className={styles.assetViewerIcon} 
                          alt="" 
                          src={viewer === "BINGE" ? '/images/lightBox/BingeSelected.svg' : '/images/lightBox/BingeDefault.svg'} 
                        />
                        <Property.RadioButton 
                          title='Binge' 
                          value={viewer === "BINGE"}
                          className={styles.radioBtn}
                          onClick={() => handleAssetViewerType('BINGE')} 
                        />
                      </div>
                      <div className={styles.defaultAsset}>
                        <img 
                          className={styles.assetViewerIcon} 
                          alt="" 
                          src={viewer === "BINGE" ? '/images/lightBox/LightboxDefault.svg' : '/images/lightBox/LightboxSelected.svg'} 
                        />
                        <Property.RadioButton 
                          title='Lightbox' 
                          value={viewer === "LIGHTBOX"}
                          className={styles.radioBtn}
                          onClick={() => handleAssetViewerType('LIGHTBOX')} 
                        />
                      </div>
                    </div>
                    <div className={cx(styles.lightboxContainer, { [styles.show]: viewer === "LIGHTBOX" })}>
                      <div className={styles.header}>Choose Theme</div>
                      <div className={styles.assetTypeContainer}>
                        <Property.RadioButton 
                          title='Dark'
                          value={darkViewer === true}
                          className={styles.radioBtn}
                          onClick={() => handleDarkView(true)} 
                        />
                        <Property.RadioButton 
                          title='Light' 
                          value={darkViewer === false}
                          className={styles.radioBtn}
                          onClick={() => handleDarkView(false)} 
                        />
                      </div>
                      <p className={styles.description}>Choose your theme with Light or Dark mode for a personalized view.</p>
                    </div>
                  </div>
                </div>
              </div>
            }
          </Col>
          <Col md={6} className={cx(styles.siteSettingsColumn)}>
            <SiteVerification
              siteVerification={siteVerification}
              onSiteVerificationChange={handleSiteVerificationChange}
              storyboard={storyboard}
            />

            <TrackingPixel storyboard={storyboard} trackingPixels={trackingPixels ? trackingPixels : []}
              handleAddNewPixel={handleAddNewPixel}
              handleTrackingPixelChange={handleTrackingPixelChange}
              deleteTrackingPixel={deleteTrackingPixel} 
            />

            <PasswordProtect
              toggleDisableProtect={toggleDisableProtect}
              password={password}
              passwordEnabled={passwordEnabled}
              onPasswordChange={handlePasswordChange}
              storyboard={storyboard}
            />

            <div className={cx(styles.siteSettingsContainer, styles.aliasContainer)}>
              <SiteSettingHeader
                title='Custom Script'
                description='Apply scripts at the storyboard level for site-wide custom abilities, comprehensive functionality and control'
              />

              <div className={cx(styles.customScript, {[styles.disabled] : !storyboardRoleService.canEditStoryboard(storyboard)})}>
                <textarea placeholder="Enter the script here" value={customScript || ""} onChange={handleCustomScriptChange}></textarea>     
              </div>
            </div>
          </Col>
        </Row>
        { INTERACTIVE_CONTENT_TYPES.includes(storyboardType) &&
          <Row className={styles.siteSettingsRow}>
            <Col md={12} className={cx(styles.siteSettingsColumn)}>
              <InteractiveAppearances 
                storyboard={storyboard} 
                appearance={appearance ? appearance : {}}
                disableDownload={appearance ? appearance.disableDownload : false}
                toggleDownload={handleToggleDownload} />
            </Col>
          </Row>
        }
          <Row className={styles.siteSettingsRow}>
            <Col md={12} className={cx(styles.siteSettingsColumn)}>
              <ContentGating storyboard={storyboard} storyboardType={storyboardType} />
            </Col>
          </Row>
        <UnPublishMessageModal updating={unpublishing} show={state.showUnpublish} onDiscard={toggleUnpublish} handleUnpublish={handleUnpublish} />
      </div>
      </div>
      {storyboardRoleService.canEditStoryboard(storyboard) &&
        <footer className={styles.buttonContainer}>
          <Button variant="secondary"
            disabled={updating}
            className={styles.resetButton}
            type="reset"
            onClick={handleResetClick}>Reset</Button>
          <Button variant="primary"
            disabled={updating}
            className={styles.saveButton}
            type="submit"
            onClick={handleSave}>{updating ? 'Saving...' : 'Save Changes'}</Button>
        </footer>}
      <MediaLibraryModal
        show={state.showMedia}
        storyboard={storyboard}
        onSelect={handleChangeSocialIcon}
        onClose={toggleUploadMedia}
        mediaTypes={['image']}
      />
    </>
  )
}

const NotificationTrigger = ({notification, handleChange, storyboardType}) => {
  let lables = [{"lable" : "Got a New Lead", "name": "leadCaptured", "value": false},
                {"lable" : "Lead Viewed a Storyboard", "name": "pageViewed", "value": false},
                {"lable" : "Lead Downloaded an Interactive Content", "name": "icDownload", "value": false},
                {"lable" : "Lead Viewed an Asset", "name": "assetViewed", "value": false},
                {"lable" : "Lead Downloaded an Asset", "name": "assetDownload", "value": false}];
  return (
    <div className={styles.notificationContainer}>
      {lables.map((value) => {
        if((value.name === 'icDownload' && !INTERACTIVE_CONTENT_TYPES.includes(storyboardType)) || (value.name === 'assetDownload' && SLIDE_STORYBOARDS.includes(storyboardType))) return null;
        return <NotificationPreferences key={value.name} option={value} notification={notification} handleChange={handleChange} />
      })
      }
    </div>
  )
}

const NotificationPreferences = ({option, notification, handleChange}) => {
  return(
    <Row className={styles.notifications}>
      <Col md="10" className={styles.column} >
        <p className={styles.lableName}>{option.lable}</p>
      </Col>
      <Col md="2" className={cx(styles.emailNotification, styles.column)} >
        <Form.Check
          className={styles.checkbox}
          type="checkbox"
          label="Email"
          name="email"
          checked={_.get(notification, `email.${option.name}`, false)}
          onChange={(e)=>{handleChange(option.name, 'email', e.target.checked)}}
        />
      </Col>
    </Row>
  )
}

const InteractiveAppearances = ({ storyboard, appearance }) => {
  const dispatch = useDispatch();

  useEffect(()=>{

    if((!appearance || !_.get(appearance, 'background') || !_.get(appearance, 'iconColor') || !_.get(appearance, 'overlay'))) {
      var initialRequest = {
        background: {type:'color', color:{r:255, g:255, b:255, a:1}},
        iconColor: {r:0, g:0, b:0, a:1},
        overlay: 'none',
        slideBackground: {type:'color', theme:'dark'}
      }
      dispatch(updateAppearance(storyboard?.id, initialRequest));
    }
  },[appearance])

  return (
    <div className={cx(styles.siteSettingsContainer, styles.appearanceContainer)}>
      <div className={styles.appearanceHeader}>
        <SiteSettingHeader
          title='Appearance'
          description='Give your visitors an enhanced experience with our viewer customization.'
        />
      </div>
        <InteractiveAppearanceSetting 
          appearance={appearance}
          storyboard={storyboard} 
        />
    </div>
  )
}

const InteractiveAppearanceSetting =({appearance, storyboard})=> {
  const dispatch = useDispatch();

  const { background, iconColor, overlay, disableDownload } = appearance;
  const imageRef = React.useRef(null);

  const handlePropertyChange = (type, data) => {
    if (data) {
      var request = {
        ...appearance,
        [type]: data
      }
      dispatch(updateAppearance(storyboard.id, request));
    }
  }

  const handleDisableDownload = (value) => {
    var request = {
      ...appearance,
      disableDownload: value
    }

    dispatch(updateAppearance(storyboard.id, request));
  }

  const getBackgroundUrl = () => {
    return _.get(background, 'media.url');
  }

  const renderNavIcons = () => {
    return (
      <div className={styles.iconsContainer}>
        <div className={styles.menuAction}>
          <i style={{ color: colorToString(iconColor) }} className={cx('cleverstory-menu', styles.menuIcon)} />
        </div>
        <div className={styles.actionContainer}>
          {!appearance.disableDownload &&
          <i style={{ color: colorToString(iconColor) }} className={cx('cleverstory-bottom', styles.actionIcons)} />}
          <i style={{ color: colorToString(iconColor) }} className={cx('cleverstory-search', styles.actionIcons)} />
          <i style={{ color: colorToString(iconColor) }} className={cx('cleverstory-expand-editor', styles.actionIcons)} />
        </div>
      </div>
    )
  }

  return (
    <>
      <div style={{ background: background ? colorToString(background.color) : '#ffffff' }} className={styles.interactiveViewer}>
        {background && background.media && background.type === 'image' &&
          <div className={styles.backgroundImage}>
            {_.get(background, 'media.type') === 'image' ?
              <ImageView
                className={styles.backgroundImage}
                imageRef={imageRef}
                url={getBackgroundUrl()}
                width={'100%'}
                height={'100%'}
              /> :
              <VideoView background={background} />
            }
          </div>
        }
        <div className={cx(styles.overlaySection, { [styles.lightOverlay]: overlay === 'light' }, { [styles.darkOverlay]: overlay === 'dark' })}></div>
        <div className={styles.headerContainer}>
          <Image src={'/images/appearanceHeader.png'} className={styles.headerImage} />
        </div>
        {renderNavIcons()}
        <div className={styles.contentSection}>
          <Image src={'/images/appearanceContent.png'} className={styles.contentImage} />
        </div>
      </div>
      <div className={styles.settingsConatiner}>
        <BackgroundAppearance background={background || {}} imageRef={imageRef} handleBackgroundChange={handlePropertyChange} />
        <IconsAppearance iconColor={iconColor} handleIconColors={handlePropertyChange} />
        <OverlaySettings overlay={overlay} handleOverlayChange={handlePropertyChange} />
        <DisableDownload disableDownload={disableDownload} handleDisableDownload={handleDisableDownload}/>
      </div>
    </>
  )
}

const BackgroundAppearance = ({ handleBackgroundChange, imageRef, background }) => {

  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard.item", null));
  const { color, media, type } = background;
  const targetRef = useRef(null);
  const [state, setState] = useState({
    show: false,
    backgroundType: 'color',
  })

  useEffect(() => {
    function handleClickOutside(event) {
      if (targetRef.current && !targetRef.current.contains(event.target)) {
        setState(state => {
          return {
            ...state,
            show: false
          }
        })
      }
    }

    window.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    }
  }, [])

  useEffect(() => {
    if (type) {
      setState(state => {
        return {
          ...state,
          backgroundType: type
        }
      })
    }
  }, [type])

  const handleToggleChange = () => {
    setState(state => {
      return {
        ...state,
        show: !state.show
      }
    })
  }

  const handleClose = () => {
    setState(state => {
      return {
        ...state,
        show: false
      }
    })
  }

  const handleChangeBackgroundImage = (media) => {
    var mediaRequest = {
      ...background,
      type: 'image',
      media: media[0],
      opacity: 100,
      color: { r: 255, g: 255, b: 255, a: 1 }
    }
    if (media) {
      handleBackgroundChange('background', mediaRequest)
    }

    setState(state => {
      return {
        ...state,
        show: false,
      }
    })
  }

  const handleTypeChange = (e) => {
    setState(state => {
      return {
        ...state,
        backgroundType: e.target.name
      }
    })
  }

  return (
    <div className={styles.settingOption}>
      <span className={styles.title}>Background</span>
      <div className={styles.actionContainer}>
        <div className={styles.checkBoxWrapper}>
          <Form.Check
            inline
            checked={state.backgroundType === 'color'}
            className={styles.radioButton}
            onClick={handleTypeChange}
            label="Color"
            name="color"
            type="radio"
            id={`inline-radio-1`}
          />
          <div style={{ backgroundColor: colorToString(color) }} onClick={handleToggleChange} className={cx(styles.swatch, { [styles.disabled]: state.backgroundType !== 'color' })}></div>
          {state.show && state.backgroundType === 'color' &&
            <div ref={targetRef} className={styles.popover}>
              <div className={styles.cover} onClick={handleClose} />
              <ChromePicker
                color={color}
                onChange={(color) =>
                  handleBackgroundChange(
                    'background',
                    {
                      ...background,
                      type: 'color',
                      color: color.rgb,
                      media: null
                    }
                  )
                }
                disableAlpha={true}
              />
            </div>
          }
        </div>
        <div className={styles.checkBoxWrapper}>
          <Form.Check
            inline
            checked={state.backgroundType === 'image'}
            onClick={handleTypeChange}
            className={styles.radioButton}
            label="Media"
            name="image"
            type="radio"
            id={`inline-radio-1`}
          />
          <Button variant="info" onClick={handleToggleChange} className={cx(styles.uploadMedia, { [styles.disabled]: state.backgroundType !== 'image' })}>
            <i className={cx('cleverstory-upload', styles.actionIcons)} />
          </Button>
        </div>
      </div>
      <MediaLibraryModal
        show={state.show && state.backgroundType === 'image'}
        storyboard={storyboard}
        onSelect={handleChangeBackgroundImage}
        onClose={handleToggleChange}
      />
    </div>
  )
}

const SlideBackgroundAppearance =({slideBackground, storyboard, handleBackgroundChange})=> {

  const [showMedia, setShowMedia] = useState(false)

  const handleChangeBackgroundImage = (media) => {
    var mediaRequest = {
      ...slideBackground,
      type: 'image',
      media: media[0],
      opacity: 100,
      color: { r: 255, g: 255, b: 255, a: 1 }
    }
    if (media) {
      handleBackgroundChange('slideBackground', mediaRequest)
    }

    setShowMedia(false)
  }


  return (
    <div className={styles.slideBackgroundOption}>
      <span className={styles.title}>Slide Background</span>
      <div className={styles.actionContainer}>
        <OverlayTrigger
          trigger="click"
          rootClose
          placement="bottom"
          overlay={
            <ThemesPopover
              slideBackground={slideBackground} 
              handleBackgroundChange={handleBackgroundChange} 
              id="popover-contained"
            />
          }
        >
          <Button active={slideBackground.type === 'color'} variant="info">
            <i className={'cleverstory-font-color'} />
          </Button>
        </OverlayTrigger>
        <Button active={_.get(slideBackground, 'media.type') === 'video'} variant="info" onClick={()=>{setShowMedia(true)}}>
          <i className={'cleverstory-Video-S'} />
        </Button>
        <Button active={_.get(slideBackground, 'media.type') === 'image'} variant="info" onClick={()=>{setShowMedia(true)}}>
          <i className={'cleverstory-background'} />
        </Button>
        <Button active={_.get(slideBackground, 'type') === 'none'} variant="info" onClick={()=>{
            handleBackgroundChange(
              'slideBackground',
              {
                ...slideBackground,
                type: 'none',
                theme: 'dark',
                color: { r: 255, g: 255, b: 255, a: 0 },
                media: null
              }
            )
          setShowMedia(false)
        }}>
          <i className={'cleverstory-none'} />
        </Button>
      </div>
    <MediaLibraryModal
      show={showMedia}
      storyboard={storyboard}
      onSelect={handleChangeBackgroundImage}
      onClose={()=>{setShowMedia(false)}}
    />
  </div>
  )
}


const ThemesPopover = React.forwardRef(
  ({ popper, children, show: _, handleBackgroundChange, slideBackground, ...props }, ref) => {

    useEffect(() => {
      popper.scheduleUpdate();

      return ()=> {
        setShowColorPicker(false);
      }
    }, [children, popper]);

    const targetRef = useRef(null);
    const [showColorPicker, setShowColorPicker] = useState(false)

    const {type, color, theme} = slideBackground;


  const handleChangeBackgroundColor = (theme) => {
    handleBackgroundChange(
      'slideBackground',
      {
        ...slideBackground,
        type: 'color',
        theme: theme,
        color: theme === 'dark' ?  { r: 98, g: 98, b: 98, a: 0.25 } : { r: 238, g: 238, b: 238, a: 0.25 },
        media: null
      }
    )
  }

    return (
      <Popover ref={ref} body {...props}>
        <div className={styles.glassThemeContainer}>
          <div 
            className={styles.themeButton}
            onClick={()=>{handleChangeBackgroundColor('dark')}}
          >
            <div className={cx(styles.darkBox, {[styles.active]: type == 'color' && theme == 'dark'})}>
              <span className={styles.swatch}/>
            </div>
            <span className={styles.title}>Dark</span>
          </div>
          <div 
            className={styles.themeButton}
            onClick={()=>{handleChangeBackgroundColor('light')}}
          >
            <div className={cx(styles.lightBox, {[styles.active]: type == 'color' && theme == 'light'})}>
              <span className={styles.swatch}/>
            </div>
            <span className={styles.title}>Light</span>
          </div>
          <div onClick={()=>{setShowColorPicker(true)}} className={styles.themeButton}>
            <div className={cx(styles.customBox, {[styles.active]: type == 'color' && theme == 'custom'})}>
              <span style={{ backgroundColor: theme == 'custom' ? colorToString(color) : '#FFC600'}}  className={styles.swatch}/>
            </div>
            <span className={styles.title}>Custom</span>
          </div>
          {showColorPicker &&
            <div ref={targetRef} className={styles.popover}>
              <div className={styles.cover} onClick={()=>setShowColorPicker(false)} />
              <ChromePicker
                color={color}
                onChange={(color) =>
                  handleBackgroundChange(
                    'slideBackground',
                    {
                      ...slideBackground,
                      type: 'color',
                      theme: 'custom',
                      color: color.rgb,
                      media: null
                    }
                  )
                }
                disableAlpha={true}
              />
            </div>
          }
          </div>
      </Popover>
    );
  },
);

const IconsAppearance = ({ handleIconColors, iconColor }) => {
  const targetRef = useRef(null);
  const [state, setState] = useState({
    show: false,
  })

  useEffect(() => {
    function handleClickOutside(event) {
      if (targetRef.current && !targetRef.current.contains(event.target)) {
        setState(state => {
          return {
            ...state,
            show: false
          }
        })
      }
    }

    window.addEventListener('mousedown', handleClickOutside);
    return () => {
      window.removeEventListener('mousedown', handleClickOutside);
    }
  }, [])

  const handleColorChange = () => {
    setState(state => {
      return {
        ...state,
        show: !state.show
      }
    })
  }

  const handleClose = () => {
    setState(state => {
      return {
        ...state,
        show: false
      }
    })
  }

  return (
    <div className={styles.settingOption}>
      <span className={styles.title}>Icons</span>
      <div className={styles.actionContainer}>
        <div className={styles.checkBoxWrapper}>
          <span className={styles.subtitle}>Icons Color</span>
          <div style={{ backgroundColor: colorToString(iconColor) }} onClick={handleColorChange} className={styles.swatch}></div>
          {state.show &&
            <div ref={targetRef} className={styles.popover}>
              <div className={styles.cover} onClick={handleClose} />
              <ChromePicker color={iconColor} onChange={(color) => handleIconColors('iconColor', color.rgb)} disableAlpha={true} />
            </div>
          }
        </div>
      </div>
    </div>
  )
}

const OverlaySettings = ({ overlay, handleOverlayChange }) => {

  const handleOnchange = (data) => {
    if (data) {
      handleOverlayChange('overlay', data.target.name);
    }
  }

  return (
    <div className={styles.settingOption}>
      <span className={styles.title}>Overlay</span>
      <div className={styles.actionContainer}>
        <div className={styles.checkBoxWrapper}>
          <div key={`inline-radio`}>
            <Form.Check
              inline
              label="None"
              onClick={handleOnchange}
              className={cx(styles.radioButton, styles.overlayRadioButton)}
              checked={overlay === 'none'}
              name="none"
              type="radio"
              id={`inline-none-1`}
            />
            <Form.Check
              inline
              label="light"
              onClick={handleOnchange}
              className={cx(styles.radioButton, styles.overlayRadioButton)}
              checked={overlay === 'light'}
              name="light"
              type="radio"
              id={`inline-light-2`}
            />
            <Form.Check
              inline
              label="dark"
              onClick={handleOnchange}
              name="dark"
              className={cx(styles.radioButton, styles.overlayRadioButton)}
              checked={overlay === 'dark'}
              type="radio"
              id={`inline-dark-3`}
            />
          </div>
        </div>
      </div>
    </div>
  )
}

const DisableDownload = ({disableDownload, handleDisableDownload}) => {

  const handleChange = () => {
    handleDisableDownload(!disableDownload);
  }

  return(
    <div className={styles.settingOption}>
      <span className={styles.title}>Download Icon</span>
      <div className={styles.actionContainer}>
        <div className={styles.checkBoxWrapper}>
          <Form.Check
            inline
            checked={!disableDownload}
            className={styles.radioButton}
            onChange={handleChange}
            label="Show Download Icon"
            name="disableDownload"
            type="checkbox"
            id="disable-download"
          />
        </div>
      </div>
    </div>
  )
}

const UnPublishMessageModal = ({ show, updating, onDiscard, handleUnpublish, pageData }) => {

  return (
    <Modal backdrop='static'
      className={styles.publishErrorModal}
      contentClassName={styles.publishErrorContent}
      dialogClassName={styles.publishErrorDialog}
      backdropClassName={styles.backdropWrapper}
      show={show}
      centered size="lg"
    >
      <Modal.Body className={styles.publishErrorBody}>
        <Image src={'/images/unPublish.png'} className={styles.saveMessageImage} />
        <Row className={styles.messageRow}>
          <Col className={styles.messageContainer} xs={{ span: 5, offset: 7 }}>
            <div>
              <h2 className={styles.messageTitle}>Unpublish Storyboard?</h2>
              <span className={styles.messageContent}>
                If you unpublish, the current URL will become inactive and lead to a 404 page. You can restore the page anytime from the Storyboard editor. Sure you want to continue?<br />
              </span>
            </div>
            <div className={styles.aliasList}>
              {pageData &&
                pageData.map((value) => (
                  <div id={value?.id} className={styles.pageInfo}>
                    <span className={styles.pageName}>{value?.id}</span>
                    <span className={styles.pageAlias}>{value.alias}</span>
                  </div>
                ))
              }
            </div>
            <footer className={styles.publishErrorButtons}>
              <Button variant="secondary" onClick={() => onDiscard()} >Close</Button>
              <Button disabled={updating} variant="primary" onClick={() => handleUnpublish()} >{updating ? "Unpublishing..." : "Unpublish"}</Button>
            </footer>
          </Col>
        </Row>
      </Modal.Body>
    </Modal>
  )
}

const SiteVerification = ({ siteVerification, onSiteVerificationChange, storyboard }) => {

  return (
    <div id="siteVerification" className={cx(styles.siteVerificationContainer)}>
      <div className={styles.headerSection}>
        <SiteSettingHeader
          title='Site Verification'
          description='To claim ownership of your site, add the provided meta tags from search engines'
        />
      </div>
      <Form.Group className={cx(styles.inputContainer, {[styles.disabled] : !storyboardRoleService.canEditStoryboard(storyboard)})}>
        <Form.Label className={styles.label}>
          <img alt="google" className={styles.icon} src='/images/siteVerification/google.svg' />
          <span>Google Search Console</span>
        </Form.Label>
        <Form.Control type='text' name="googleVerification" value={_.get(siteVerification, 'googleVerification', '')} onChange={onSiteVerificationChange} className={styles.verificationField} placeholder={`Enter Google Site Verification Code`}/>
          <span className={styles.instruction}>To get a verification meta tag, go to  
            <a className={styles.link} href="https://search.google.com/search-console/welcome" target="_blank" rel="noopener noreferrer">Google Search Console</a>
          </span>
      </Form.Group>
    </div>
  )
}

const TrackingPixel = (props) => {

  var GOOGLE_ANALYTICS = props.trackingPixels.filter(pixel => pixel.type === "GOOGLE_ANALYTICS");
  var GOOGLE_TAG_MANAGER = props.trackingPixels.filter(pixel => pixel.type === "GOOGLE_TAG_MANAGER");
  var FACEBOOK = props.trackingPixels.filter(pixel => pixel.type === "FACEBOOK");
  var LINKEDIN = props.trackingPixels.filter(pixel => pixel.type === "LINKEDIN");
  var MUNCHKIN = props.trackingPixels.filter(pixel => pixel.type === "MUNCHKIN");
  var SIXSENSE = props.trackingPixels.filter(pixel => pixel.type === "SIXSENSE");

  return (
    <div className={cx(styles.siteSettingsContainer, styles.trackingPixelsContainer)}>
      <div className={styles.trackingPixelsHeader}>
        <SiteSettingHeader
          title='Tracking Pixels'
          description='Pixels help track page traffic, interactions, conversions and more.'
        />
        <Dropdown className={cx(styles.filter, {[styles.disabled] : !storyboardRoleService.canEditStoryboard(props.storyboard)})}>
          <Dropdown.Toggle className={styles.selected}>
              <Button variant='secondary' className={styles.addPixelButton}>
                <i className={'cleverstory-plus'} />
                Add Pixel
              </Button>
          </Dropdown.Toggle>

          <Dropdown.Menu className={styles.trackingPixelsMenu}>
            {trackingPixels.pixels.map((pixel) => {
              return (
                <Dropdown.Item onClick={() => props.handleAddNewPixel(pixel)}>
                  <img alt="Pixel Icon" className={styles.icon} src={`/images/trackingPixels/${pixel.icon}.png`} />
                  {pixel.name}
                </Dropdown.Item>
              )
            })}
          </Dropdown.Menu>
        </Dropdown>
      </div>
      <Form.Group className={cx(styles.siteFormGroup, {[styles.disabled] : !storyboardRoleService.canEditStoryboard(props.storyboard)})}>
        <div className={styles.trackingPixel}>
          {GOOGLE_ANALYTICS.length > 0 &&
            <Form.Label> 
              <img alt="google analytics" className={styles.icon} src='/images/trackingPixels/googleAnalytics.png' />
              Google Analytics
            </Form.Label>}
          {GOOGLE_ANALYTICS.map((pixel) => {
            return (
              <TrackingPixelInput pixel={pixel} storyboard={props.storyboard} handleTrackingPixelChange={props.handleTrackingPixelChange} deleteTrackingPixel={props.deleteTrackingPixel} />
            )
          })}
          {GOOGLE_TAG_MANAGER.length > 0 &&
            <Form.Label>
              <img alt="google tag manager" className={styles.icon} src='/images/trackingPixels/googleTagManager.png' />
              Google Tag Manager
            </Form.Label>}
          {GOOGLE_TAG_MANAGER.map((pixel) => {
            return (
              <TrackingPixelInput pixel={pixel} storyboard={props.storyboard} handleTrackingPixelChange={props.handleTrackingPixelChange} deleteTrackingPixel={props.deleteTrackingPixel} />
            )
          })}
          {FACEBOOK.length > 0 &&
            <Form.Label>
              <img alt="facebook" className={styles.icon} src='/images/trackingPixels/facebook.png' />
              Facebook
            </Form.Label>}
          {FACEBOOK.map((pixel) => {
            return (
              <TrackingPixelInput pixel={pixel} storyboard={props.storyboard} handleTrackingPixelChange={props.handleTrackingPixelChange} deleteTrackingPixel={props.deleteTrackingPixel} />
            )
          })}
          {LINKEDIN.length > 0 &&
            <Form.Label>
              <img alt="linkedIn" className={styles.icon} src='/images/trackingPixels/linkedIn.png' />
              LinkedIn
            </Form.Label>}
          {LINKEDIN.map((pixel) => {
            return (
              <TrackingPixelInput pixel={pixel} storyboard={props.storyboard} handleTrackingPixelChange={props.handleTrackingPixelChange} deleteTrackingPixel={props.deleteTrackingPixel} />
            )
          })}
          {MUNCHKIN.length > 0 &&
            <Form.Label>
              <img alt="Munchkin" className={styles.icon} src='/images/trackingPixels/munchkin.png' />
              Munchkin</Form.Label>}
          {MUNCHKIN.map((pixel) => {
            return (
              <TrackingPixelInput storyboard={props.storyboard} pixel={pixel} handleTrackingPixelChange={props.handleTrackingPixelChange} deleteTrackingPixel={props.deleteTrackingPixel} />
            )
          })}
          {SIXSENSE.length > 0 &&
            <Form.Label>
              <img alt="6Sense" className={styles.icon} src='/images/trackingPixels/sixSense.png' />
              6sense</Form.Label>}
          {SIXSENSE.map((pixel) => {
            return (
              <TrackingPixelInput storyboard={props.storyboard} pixel={pixel} handleTrackingPixelChange={props.handleTrackingPixelChange} deleteTrackingPixel={props.deleteTrackingPixel} />
            )
          })}
        </div>
      </Form.Group>
    </div>
  )
}

const TrackingPixelInput = (props) => {
  return (
    <InputGroup key={props.pixel.uid} className={cx(styles.siteInputGroup, styles.pixelInput)}>
      <Form.Control
        type="text"
        placeholder="Enter tracking pixels"
        disabled={!storyboardRoleService.canEditStoryboard(props.storyboard)}
        onChange={props.handleTrackingPixelChange.bind(this, props.pixel.type, props.pixel.uid)}
        value={props.pixel.value}
        aria-describedby="tracking-pixel-code"
      />
      {storyboardRoleService.canEditStoryboard(props.storyboard) &&
        <Button className={styles.action} onClick={props.deleteTrackingPixel.bind(this, props.pixel.uid)}>
          <i className='cleverstory-close' />
        </Button>
      }
    </InputGroup>
  )
}

const PasswordProtect = ({ password, passwordEnabled, onPasswordChange, toggleDisableProtect, storyboard }) => {
  const [visible, setVisible] = useState(false);

  const handlePasswordType = () => {
    setVisible(!visible)
  }
  return (
    <div id="passwordProtect" className={cx(styles.passwordConatiner)}>
      <div className={styles.headerSection}>
        <SiteSettingHeader
          title='Password Protect'
          description='Only visitors with this password will be allowed to access the published URL.'
        />
        <Form.Check
          type="switch"
          disabled={!passwordEnabled && password.length < 1}
          checked={passwordEnabled}
          onChange={toggleDisableProtect}
          className={cx(styles.toggleSwitch, {[styles.disabled] : !storyboardRoleService.canEditStoryboard(storyboard)})}
          id="password-protect"
        />
      </div>
      <InputGroup className={cx({[styles.disabled] : !storyboardRoleService.canEditStoryboard(storyboard)})}>
        <Form.Control 
          type={visible ? 'text' : 'password'} 
          autoComplete="new-password" 
          value={password} 
          onChange={onPasswordChange} 
          className={styles.passwordField} 
          aria-describedby="hide-unhide" 
          placeholder={passwordEnabled ? "********" : "Enter your password."} 
        />
        <Button variant="outline-secondary" id="hide-unhide" className={styles.hideButton} onClick={handlePasswordType}>
          <i className={cx(styles.icon, { 'cleverstory-view': visible, 'cleverstory-hide': !visible })} />
        </Button>
      </InputGroup>
    </div>
  )
}


const StoryboardInfoView = ({ name, password, onNameChange, toggleUnpublish, error,selectedDomain, resetting }) => {
  const history = useHistory();
  const inputRef = React.useRef(null);

  const [state, setState] = useState({
    rename: false,
    errorMessage: error
  });

  let { url } = useRouteMatch();
  let baseUrl = getBaseUrl(url);
  const storyboard = useSelector((state) => _.get(state, "storyboards.storyboard.item", null));
  const storyboardType = _.get(storyboard, 'type', '');
  var domain = useSelector(state => _.get(state, 'workspaces.workspace.item.defaultDomain.url') || "");
  const canonical = _.get(storyboard, 'page.canonical') || "";
  const pageId = _.get(storyboard, 'page.id');
  const icon = _.get(storyboard, 'page.icon.url');
  const liveUrl = `${_.get(selectedDomain, 'url')}${canonical}`;
  const published = _.get(storyboard, 'page.published');
  const changes = _.get(storyboard, 'page.changes');

  const handleInviteClick = () => {
    history.push(`${baseUrl}/storyboards/${storyboard.id}/permissions`);
  }

  useEffect(() => {
    setState((prev) => ({
      ...prev,
      errorMessage: error
    }));
  }, [error]);

  useEffect(() => {
    setState(prev => ({
      ...prev,
      rename: false
    }));
  }, [resetting]);

  const toggleEditClick = () => {
    if (!name || name.trim() === '') {
      setState((prev) => ({
        ...prev,
        errorMessage: 'Please provide a valid name'
      }));
      return;
    }
    setState(state => {
      return {
        ...state,
        rename: !state.rename,
        errorMessage: ''
      }
    })
  }

  const handleLiveSiteClicked = () => {
    if (canonical) {
      const win = window.open(liveUrl, "_blank");
      win.focus();
    }
  }

  const handleUrlCopy = () => {
    navigator.clipboard.writeText(liveUrl).then(
      () => { },
      () => { }
    )

    toast(
      <SuccessToast
        heading={`Success`}
        description={`Copied link to clipboard!`}
      />,
      {
        type: toast.TYPE.DEFAULT,
        position: toast.POSITION.BOTTOM_RIGHT,
        autoClose: 3000,
      }
    );
  }

  const handleScrollToPassword = () => {
    const passwordConatiner = document.getElementById('passwordProtect');
    passwordConatiner.scrollIntoView({ behavior: "smooth", block: "start", inline: "nearest" })
  }

  return (
    <section className={styles.dashboardInfo}>
      <aside className={styles.storyboardImageContainer}>
        {icon &&
          <IKImage
            className={styles.storyboardImage}
            path={icon}
            transformation={[{
              "width": "600"
            }]}
          />
        }
        {!icon &&
          <img className={styles.storyboardImage} src={'/images/storyboard.png'} alt="" />
        }
      </aside>
      <aside className={styles.storyboardDetailsContainer}>
        <div className={styles.storyboardInfo}>
          <div className={styles.storyboardBasics}>
            {!state.rename &&
              <div className={styles.storyboardNameContainer}>
                <TruncatedTextWithTooltip placement="top" maxWidth={400} className={styles.name} content={name}>
                  <h2>{name}</h2>
                </TruncatedTextWithTooltip>
                {storyboardRoleService.canEditStoryboard(storyboard) &&
                  <i className={cx("cleverstory-edit", styles.editIcon)} onClick={toggleEditClick} />
                }
              </div>
            }
            {storyboardRoleService.canEditStoryboard(storyboard) && state.rename &&
              <Form.Group className={styles.siteNameFormGroup}>
                <Form.Control
                  type="text"
                  ref={inputRef}
                  placeholder="Enter storyboard name"
                  value={name}
                  onChange={onNameChange}
                  onBlur={toggleEditClick}
                  isInvalid={state.errorMessage} />
                <Form.Control.Feedback type="invalid" className={styles.error}>
                  {state.errorMessage}
                </Form.Control.Feedback>
              </Form.Group>
            }
            {published &&
              <span className={styles.viewUrl} onClick={handleLiveSiteClicked}>
                <TruncatedTextWithTooltip placement="top" maxWidth={400} content={liveUrl} />
              </span>
            }
            {password && 
              <div className={cx(styles.protectedStatus, styles.protectedLabel)}>
                <label>PASSWORD PROTECTED</label> <i className={cx("cleverstory-hide", styles.labelIcon)} />
              </div>
            }
          </div>
          <div className={styles.dateInfo}>
            <span className={styles.lastPublished}>
              Role: {storyboard.role}
            </span>
            {published &&
              <span className={styles.lastPublished}>
                Published: {dateformat(storyboard.page.lastPublished, "dd mmm yyyy")}
              </span>
            }
            <span className={styles.lastPublished}>
              {(changes || !published) &&
                <label className={cx(styles.status, styles.draft)}>DRAFT</label>
              }
              Last Saved: {dateformat(storyboard.page.modifiedDate, "dd mmm yyyy")}
            </span>
          </div>
        </div>
        <div className={styles.storyboardMetadata}>
          <div className={styles.externalEmbed}>
            <div className={styles.copyLink} onClick={handleUrlCopy}>
              <i className={cx("cleverstory-link")} /> Copy Link
            </div>
            { !SLIDE_STORYBOARDS.includes(storyboardType) && 
              <CopyEmbedCodeButton id={pageId} domain={_.get(selectedDomain, "url", domain)} height={815}>
                <div className={styles.copyLink}>
                  <i className={cx("cleverstory-Embed")} /> Copy Embed Code
                </div>
              </CopyEmbedCodeButton>
            }
          </div>
          <div className={styles.unPublishButton}>
            {storyboardRoleService.canManageStoryboard(storyboard) && INTERACTIVE_CONTENT_TYPES.includes(storyboardType) &&
              <Button hidden={!published} size="sm" variant="secondary" onClick={toggleUnpublish}>
                  Unpublish
              </Button>
            }
          </div>
        </div>
      </aside>
    </section>
  )
}

const SiteSettingHeader = ({ title, description }) => {

  return (
    <header className={styles.siteSettingsHeader}>
      <h2 className={styles.title}>{title}</h2>
      <p className={styles.description}>{description}</p>
    </header>
  )
}

const ImageView = ({ imageRef, url, width, height, crop }) => {
  var transformation = [];

  if (crop) {
    transformation.push({
      width: crop.zoomWidth,
      height: crop.zoomHeight
    });

    transformation.push({
      cropMode: 'extract',
      x: crop.x,
      y: crop.y,
      width: width,
      height: height
    });
  }

  transformation.push({
    quality: 80,
    format: 'webp'
  })

  return (
    <IKImage
      className={styles.imageView}
      ref={imageRef}
      path={url}
      width={width}
      height={height}
      transformation={transformation}
    />
  );
};

const CustomFilterDropdown = React.forwardRef(({ children, onClick }, ref) => (
  <span
    ref={ref}
    onClick={(e) => {
      e.preventDefault();
      onClick(e);
    }}
    className={styles.dropDownToggle}
  >
    {children}
    <i className={cx("cleverstory-drop-down", styles.dropdownIcon)} />
  </span>
));


const StoryboardLevelIndexing = ({ storyboard }) => {
  const dispatch = useDispatch();
  
  // Optimistically handle the 'off' state to bypass background queue delays
  const [localSeekOverride, setLocalSeekOverride] = useState(null);

  const seekIndexing = useSelector(state => state.storyboards.storyboard.seekIndexing);

  const { 
    seekEnabled = storyboard?.page?.seekEnabled, 
    seekStatus = storyboard?.page?.seekStatus 
  } = seekIndexing || {};

  const seekInProgress = SEEK_IN_PROGRESS.includes(seekStatus) || seekStatus === SEEK_STATUS.PROCESSING;
  
  // Determine if switch should be ON (prioritizing local override)
  const isChecked = localSeekOverride ?? (seekEnabled || seekInProgress);

  const toggleStoryboardSeekIndexing = useCallback(() => {
    const nextValue = !seekEnabled;
    setLocalSeekOverride(nextValue === false ? false : null);

    const request = {
      contentType: "storyboard",
      content: storyboard?.id,
      contentMapping: null,
      storyboard: storyboard?.id,
      storyboardType: storyboard?.type,
      addStoryboard: nextValue,
    };

    dispatch(storyboardLevelSeekIndex(storyboard?.id, request));
  }, [dispatch, storyboard, seekEnabled]);

  useEffect(() => {
    if (seekStatus === SEEK_STATUS.ERROR) {
      setLocalSeekOverride(null);
      toast(
        <FailureToast
          heading={"Failed"}
          description={"Unable to index for seek"}
        />,
        {
          type: toast.TYPE.DEFAULT,
          position: toast.POSITION.BOTTOM_RIGHT,
          autoClose: 3000,
        }
      );
    }
  }, [seekStatus]);

  return (
    <Form.Group controlId="storyboardLevelSeekIndex" className={cx(styles.indexSmallGroup, styles.flexFormGroup)}>
      <Form.Label className={styles.inlineLabel}>Index for seek</Form.Label>
      
      {seekInProgress && isChecked && (
        <div className={styles.loader}>
          <span className={styles.text}>Indexing...</span>
          <Button variant="info" onClick={toggleStoryboardSeekIndexing}>
            <i className="cleverstory-sync" />
          </Button>
        </div>
      )}

      <Form.Check type="switch" className={styles.switchButton}>
        <FormCheck.Input
          disabled={seekInProgress && isChecked}
          onChange={toggleStoryboardSeekIndexing}
          checked={isChecked}
        />
      </Form.Check>
    </Form.Group>
  );
};